






















































































































































































































import { Component, Vue } from 'vue-property-decorator';
@Component({})
export default class PassengerEditModal extends Vue {
  dialog: boolean = true;

  passport: Date = null;
  birthday: Date = null;

  created() {}

  data() {
    return {
      citizenItems: ['Russian Federation', 'Turkey'],
      citizen: [],

      genderItems: ['Kadın', 'Erkek'],
      gender: [],
    };
  }

  closeDialog() {
    this.$emit('closed');
  }
}
